import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import blogs from "../../../data/blogs";
import BlogCard from "../BlogCard/BlogCard";
import FeaturedBlog from "../FeaturedBlog/FeaturedBlog";
import FilterTags from "../FilterTags/FilterTags";
import Seo from "../../SEO/Seo";
import { SITE_URL } from "../../../config";
import "./BlogPage.css";

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("Hepsi");

  const featured = useMemo(() => blogs.find((blog) => blog.featured), []);

  const categories = useMemo(
    () => [...new Set(blogs.map((blog) => blog.category))],
    []
  );

  const filteredBlogs = useMemo(
    () =>
      [...blogs]
        .filter((blog) =>
          selectedCategory === "Hepsi"
            ? !blog.featured
            : blog.category === selectedCategory
        )
        .sort((a, b) => new Date(b.date) - new Date(a.date)),
    [selectedCategory]
  );

  const showFeatured = featured && selectedCategory === "Hepsi";

  const blogJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "Lingify Blog",
      url: `${SITE_URL}/blog`,
      blogPost: [...blogs]
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .map((blog) => ({
          "@type": "BlogPosting",
          headline: blog.title,
          url: `${SITE_URL}/blog/${blog.slug}`,
          datePublished: blog.date,
          image: blog.image ? `${SITE_URL}${blog.image}` : undefined,
        })),
    }),
    []
  );

  return (
    <div className="blog-page">
      <Seo
        title="Blog"
        description="Afazi, nörojenik iletişim bozuklukları ve dil terapisi üzerine güncel yazılar, makaleler ve haberler."
        canonical="/blog"
        jsonLd={blogJsonLd}
      />

      {/* Breadcrumb */}
      <nav className="blog-breadcrumb" aria-label="breadcrumb">
        <div className="blog-breadcrumb-inner">
          <Link to="/">Ana Sayfa</Link>
          <FiChevronRight />
          <span className="current">Blog</span>
        </div>
      </nav>

      <div className="blog-content">
        {showFeatured && (
          <section className="featured-section">
            <FeaturedBlog blog={featured} />
          </section>
        )}
        <div className="blog-header">
          <FilterTags
            categories={categories}
            selected={selectedCategory}
            onSelect={setSelectedCategory}
          />
        </div>
      </div>

      <div className="blog-grid">
        {filteredBlogs.length > 0 ? (
          filteredBlogs.map((blog) => <BlogCard key={blog.id} blog={blog} />)
        ) : (
          <p className="blog-empty">Bu kategoride henüz yazı bulunmuyor.</p>
        )}
      </div>
    </div>
  );
};

export default BlogPage;
